const state = {
  locale: '',
  appLoaded: false,
  snackbar: '',
  drawer: null,
  loading: false,
  newsUnreadCount: 0,
  confirm: {
    show: false,
    title: null,
    text: null,
    resolveText: null,
    rejectText: null,
    persistent: false,
    promise: null,
    deferred: null,
  },
}

const getters = {
  /* eslint-disable no-shadow */
  appLoaded: state => state.appLoaded,
  drawer: state => state.drawer,
  snackbar: state => state.message,
  loading: state => state.loading,
  newsUnreadCount: state => state.newsUnreadCount,
  confirm: state => state.confirm,
  locale: state => state.locale,
}

const mutations = {
  set(state, { type, value }) {
    state[type] = value
  },
}

const actions = {
  setLocale({ commit }, payload) {
    commit('set', { type: 'locale', value: payload })
  },
  setAppLoaded({ commit }, payload) {
    commit('set', { type: 'appLoaded', value: payload })
  },
  setSnackbar({ commit }, payload) {
    commit('set', { type: 'snackbar', value: payload })
  },
  toggleDrawer({ commit, getters }) {
    commit('set', { type: 'drawer', value: !getters.drawer })
  },
  setLoading({ commit }, payload) {
    commit('set', { type: 'loading', value: payload })
  },
  setNewUnreadCount({ commit }, payload) {
    commit('set', { type: 'newsUnreadCount', value: payload })
  },
  showConfirm({ commit, state }, payload) {
    let deferred = null
    const promise = new Promise(((resolve, reject) => {
      deferred = { resolve: resolve, reject: reject }
    }))
    commit('set', { type: 'confirm',
      value: { show: true,
        title: payload.title,
        text: payload.text,
        resolveText: payload.resolveText,
        rejectText: payload.rejectText,
        persistent: payload.persistent,
        promise: promise,
        deferred: deferred } })
    return state.confirm.promise
  },
  hideConfirm({ commit }) {
    commit('set', { type: 'confirm',
      value: { show: false,
        title: null,
        text: null,
        resolveText: null,
        rejectText: null,
        persistent: false,
        promise: null,
        deferred: null } })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/tools.js